export default {
  init() {
    // JavaScript to be fired on all pages

  },
  finalize() {

    var navThemeBeforeContactToggle;
    var globalSlide = 0;

    var stopVideo = function ( element ) {
      var iframe = element.querySelector( 'iframe');
      var video = element.querySelector( 'video' );
      if ( iframe ) {
        var iframeSrc = iframe.src;
        iframe.src = iframeSrc;
      }
      if ( video ) {
        video.pause();
      }
    };

    function isSafari() {
      return navigator.vendor &&
        navigator.vendor.indexOf('Apple') > -1 &&
        navigator.userAgent &&
        !navigator.userAgent.match('CriOS');
    }
    // JavaScript to be fired on all pages, after page specific JS is fired
    function toggleContact() {
      var $contactLink = $('#contact');
      var $contactOverlay = $('#contact-overlay');
      var $contactContent = $('#contact-content');
      if($contactOverlay.hasClass('show')){
        $contactLink.removeClass('active');
        $contactOverlay.removeClass('show');
        $contactContent.removeClass('show');
        setTimeout(function(){
          $contactContent.css({display: 'none'});
        }, 300);

        if(navThemeBeforeContactToggle) {
          $('header#header').addClass('light');
          navThemeBeforeContactToggle = '';
        }
      } else {
        $contactLink.addClass('active');
        $contactContent.css({display: 'inline-block'});
        setTimeout(function(){
          $contactOverlay.addClass('show');
          $contactContent.addClass('show');
        }, 10);


        if($('header#header').hasClass('light') && $('.main-slider-mobile:visible').length) {
          navThemeBeforeContactToggle = 'light';
          $('header#header').removeClass('light');
        } else {
          navThemeBeforeContactToggle = '';
        }

      }
    }

    $('#contact, #contact-overlay').on('click', function(e){
      e.preventDefault();
      toggleContact();
    });

    //Exhibitions nav link handle
    if(!$("body.single-exhibition").length) {
      $('nav .subnav-holder, #exhibitions-sub').hover(
        function(){ //mouseenter
          if($(window).width() < 760) {
            return;
          }
          let $submenu = $('#exhibitions-sub');
          $submenu.addClass('shown').addClass('keepShown');
        },
        function(){ //mouseleave
          if($(window).width() < 760) {
            return;
          }
          let $submenu = $('#exhibitions-sub');
          setTimeout(() => {
            if(!$submenu.hasClass('keepShown')) {
              $submenu.removeClass('shown');
            }
          }, 400);
          $submenu.removeClass('keepShown');
        }
      );
      $('#exhibitions-link').on('click', function(e){
        if($(window).width() >= 760) {
          return;
        }

        e.preventDefault();
        let $submenu = $('#exhibitions-sub');
        $submenu.toggleClass('shown');
        return false;
      });
    }
    //END Exhibitions nav link handle

    // Slider nav
    function sliderNavigation(sliderClass, direction) {
      if ($('.filter-container').length) {
        let currentSlideIndex = $('.' + sliderClass + ' .slick-slide.slick-active').data('slick-index')
        let nextVisibleSlider = direction === "slickNext" ?
          $('.merrick-portfolio-item img[data-slide-index=' + currentSlideIndex + ']').parents('.merrick-portfolio-item').nextAll(':visible').find('img').data('slide-index')
          :
          $($('.merrick-portfolio-item img[data-slide-index=' + currentSlideIndex + ']').parents('.merrick-portfolio-item').prevAll(':visible')[0]).find('img').data('slide-index');

        if (!nextVisibleSlider) {
          nextVisibleSlider = $('.merrick-portfolio-item:visible').find('img').data('slide-index');
          $('.' + sliderClass).slick('slickGoTo', nextVisibleSlider);
        } else {
          if (currentSlideIndex === nextVisibleSlider) {
            $('.' + sliderClass).slick(direction);
          } else {
            $('.' + sliderClass).slick('slickGoTo', nextVisibleSlider);
          }
        }
      } else {
        $('.' + sliderClass).slick(direction);
      }
    }

    $('.nav-container .nav-arrow-r').on('click', function(){
      sliderNavigation("main-slider", "slickNext");
    });

    $('.nav-container .nav-arrow-l').on('click', function(){
      sliderNavigation("main-slider", "slickPrev");
    });

    $('.nav-container-mobile .nav-arrow-r').on('click', function(){
      sliderNavigation("main-slider-mobile", "slickNext");
    });

    $('.nav-container-mobile .nav-arrow-l').on('click', function(){
      sliderNavigation("main-slider-mobile", "slickPrev");
    });

    $('body:not(.template-about)').on('click', '.nav-click-receiver-left', function(e) {
      e.preventDefault();
      sliderNavigation( $(window).width() < 768 ? "main-slider-mobile" : "main-slider", "slickPrev");
    });

    $('body:not(.template-about)').on('click', '.nav-click-receiver-right', function(e) {
      e.preventDefault();
      sliderNavigation( $(window).width() < 768 ? "main-slider-mobile" : "main-slider", "slickNext");
    });

    $('body').on('click', '.size img, .size .close-button', function(e) {
        e.preventDefault();
        if($(window).width()<768){
          if($('body').hasClass('is-fullscreen')) {
            $('body').removeClass('is-fullscreen');
          } else {
            $('body').addClass('is-fullscreen');
          }
        }
    });

    $(document).keydown(function(e) {

      if($('.slider-container').length && $('.slider-container').hasClass('show')) {
        switch(e.which) {
          case 37: // left
            e.preventDefault();
            if($(window).width()<760){
              $('.main-slider-mobile').slick("slickPrev");
            } else {
              $('.main-slider').slick("slickPrev");
            }
            break;

          case 39: // right
            e.preventDefault();
            if($(window).width()<760){
              $('.main-slider-mobile').slick("slickNext");
            } else {
              $('.main-slider').slick("slickNext");
            }
            break;
        }
      }
      return true;
    });

    function initImage(that){
      $(that).attr("src",$(that).data('src'));
      $(that).attr("srcset",$(that).data('srcset'));
      $(that).removeClass('lazyload');
      $(that).addClass('lazyloaded');
    }

    function initBgImage(that){
      if($(that).data('style')) {
        $(that).attr('style', $(that).data('style'));
      }
      $(that).find('.size').each(function() {
        if($(this).data('style')) {
          $(this).attr('style', $(this).data('style'));
        }
      });
    }

    function lasyLoadSlides(slick, slide){
      var currentSlide = $(slick.$slides.get(slide));
      var slider = $('.slick-slider:visible');

      // current slide
      currentSlide.find('.lazyload').each(function(){
        initImage(this);
      });
      slider.find('.slick-active').each(function(){
        initBgImage(this);
      });

      // next slide
      currentSlide.next().find('.lazyload').each(function(){
        initImage(this);
      });

      slider.find('.slick-active').next().each(function(){
        initBgImage(this);
      });

      // prev slide
      currentSlide.prev().find('.lazyload').each(function(){
        initImage(this);
      });
      slider.find('.slick-active').prev().each(function(){
        initBgImage(this);
      });
    }

    // Slider after change event
    function changeColorTheme(event, slick, currentSlide) {
      if($(window).width() < 768) {
        if($('body').hasClass('page-template-default')){
          $('.nav-arrow-l').addClass('light');
          $('.nav-arrow-r').addClass('light');
          $('header').addClass('light');
        } else {
          $('.nav-arrow-l').removeClass('light');
          $('.nav-arrow-r').removeClass('light');
          $('header').removeClass('light');
        }
      } else if($(slick.$slides.get(currentSlide)).closest('.main-slider').length) {
        // Left section
        if( $(slick.$slides.get(currentSlide)).find('.grid-type').data('nav-l-color') === 'white'){
          if(
            $(slick.$slides.get(currentSlide)).find('.i-left').length &&
            $(slick.$slides.get(currentSlide)).find('.i-left').hasClass('large')
            ||
            !$(slick.$slides.get(currentSlide)).find('.i-left').length &&
            $(slick.$slides.get(currentSlide)).find('.size').hasClass('large')
          ) {
            $('.nav-arrow-l').addClass('light');
          } else {
            $('.nav-arrow-l').removeClass('light');
          }

        } else if($('body').hasClass('page-template-default')){
          $('.nav-arrow-l').addClass('light');
        } else {
          $('.nav-arrow-l').removeClass('light');
        }
        // Right section
        if( $(slick.$slides.get(currentSlide)).find('.grid-type').data('nav-r-color') === 'white' ){
          if(
            $(slick.$slides.get(currentSlide)).find('.i-right').length &&
            $(slick.$slides.get(currentSlide)).find('.i-right').hasClass('large')
            ||
            !$(slick.$slides.get(currentSlide)).find('.i-right').length &&
            $(slick.$slides.get(currentSlide)).find('.size').hasClass('large')
          ) {
            $('.nav-arrow-r').addClass('light');
          } else {
            $('.nav-arrow-r').removeClass('light');
          }

        } else if($('body').hasClass('page-template-default')){
          $('.nav-arrow-r').addClass('light');
        } else {
          $('.nav-arrow-r').removeClass('light');
        }

        // Bottom section
        if ($(slick.$slides.get(currentSlide)).find('.grid-type').data('nav-b-color') === 'white') {
          if ($(slick.$slides.get(currentSlide)).find('.size').hasClass('large')) {
            $('.back-to-gallery-container').addClass('light');
            $('.back-to-gallery-container').removeClass('dark');
          } else {
            $('.back-to-gallery-container').removeClass('light');
            $('.back-to-gallery-container').addClass('dark');
          }
        } else if ($(slick.$slides.get(currentSlide)).find('.grid-type').data('nav-b-color') === 'black') {
          if ($(slick.$slides.get(currentSlide)).find('.size').hasClass('large')) {
            $('.back-to-gallery-container').removeClass('light');
            $('.back-to-gallery-container').addClass('dark');
          } else {
            $('.back-to-gallery-container').addClass('light');
            $('.back-to-gallery-container').removeClass('dark');
          }
        } else if ($('body').hasClass('page-template-default')) {
          $('.back-to-gallery-container').addClass('light');
          $('.back-to-gallery-container').removeClass('dark');
        } else {
          $('.back-to-gallery-container').addClass('dark');
          $('.back-to-gallery-container').removeClass('light');

        }

        // Top section
        if( $(slick.$slides.get(currentSlide)).find('.grid-type').data('nav-t-color') === 'white' ){
          $('header').addClass('light');
        } else if($('body').hasClass('page-template-default')){
          $('header').addClass('light');
        } else {
          $('header').removeClass('light');
        }
      }
    }

    $('.back-to-gallery-container').on('click', function(){
      if($('body').hasClass('home')) {
        $('a#home')[0].click();
      }
    });

    function detectVideo(slick, currentSlide) {
      var $currentSlide = $(slick.$slides.get(currentSlide));
      if( $currentSlide.find('.grid-type').hasClass('single-video') ){
        var iframe = $currentSlide.find('iframe');

        if ($(window).width() >= 760 && $currentSlide.parents('.main-slider').length ) {
          $currentSlide.find('.embed-container').width( iframe.width() );
          $currentSlide.find('.embed-container').height( iframe.height() );
        }

        if( !$(iframe).data('video-ran') ){
          var randomNum = Math.floor(Math.random()*10000);
          iframe.data('video-ran',randomNum);
          iframe.addClass('playing');
        }
      }
    }

    function pauseVideo(slick, currentSlide) {
      var $currentSlide = $(slick.$slides.get(currentSlide));
      if( $currentSlide.find('.grid-type').hasClass('single-video') ){
        stopVideo($currentSlide[0]);

        if ($(window).width() >= 760 && $currentSlide.parents('.main-slider').length ) {
          $currentSlide.find('.embed-container').width( '100%' );
          $currentSlide.find('.embed-container').height( '100%' );
        }

        var iframe = $currentSlide.find('iframe');
        iframe.removeClass('playing');
      }
    }

    // Update Url and title
    function updateURLnTitle(slick, currentSlide) {
      var $currentSlide = $(slick.$slides.get(currentSlide));
      var slideIndex = $currentSlide.data('slick-index');
      if( slideIndex>=0 ){
        var url = "#"+slideIndex;
        window.history.pushState({"pageTitle":"Merrick d'Arcy-Irvine"},"", url);
      }
    }

    function syncMobileSlider(globalSlide){
      var mobileSlideIndex;
      if( $( $('.main-slider-mobile .grid-type[data-global-index="'+globalSlide+'"]')[0] ).parents(".slick-slide").hasClass('slick-cloned') ){
        mobileSlideIndex = $( $('.main-slider-mobile .grid-type[data-global-index="'+globalSlide+'"]')[1] ).parents(".slick-slide").data('slick-index');
      } else {
        mobileSlideIndex = $( $('.main-slider-mobile .grid-type[data-global-index="'+globalSlide+'"]')[0] ).parents(".slick-slide").data('slick-index');
      }

      $('.main-slider-mobile').slick('slickGoTo', mobileSlideIndex);
    }

    function syncMainSlider(globalSlide){
      var mainSliderIndex;

      if( $( $('.main-slider .grid-type[data-global-index="'+globalSlide+'"]')[0] ).parents(".slick-slide").hasClass('slick-cloned') ){
        mainSliderIndex = $( $('.main-slider .grid-type[data-global-index="'+globalSlide+'"]')[1] ).parents(".slick-slide").data('slick-index');
      } else {
        mainSliderIndex = $( $('.main-slider .grid-type[data-global-index="'+globalSlide+'"]')[0] ).parents(".slick-slide").data('slick-index');
      }

      $('.main-slider').slick('slickGoTo', mainSliderIndex);
    }

    function updateUrlWithNoHistory(slideIndex) {
        if( slideIndex>=0 ){
            var url = "#"+slideIndex;
            window.history.replaceState({"pageTitle":"Merrick d'Arcy-Irvine"},"", url);
        }
    }

    $('.main-slider').on('init', function(event, slick){
      if ($(window).width() >= 760) {
        changeColorTheme(event, slick, 0);
        detectVideo(slick, 0);
        lasyLoadSlides(slick, 0);
      }
    });

    $('.main-slider').on('afterChange', function(event, slick, currentSlide){
      if ($(window).width() >= 760) {
        changeColorTheme(event, slick, currentSlide);
        updateURLnTitle(slick, currentSlide);
        detectVideo(slick, currentSlide);
        lasyLoadSlides(slick, currentSlide);
        globalSlide = $(slick.$slides.get(currentSlide)).find(".grid-type").data('global-index');
        syncMobileSlider(globalSlide);
      }
    });

    $('.main-slider').on('beforeChange', function(event, slick, currentSlide){
      if ($(window).width() >= 760) {
        pauseVideo(slick, currentSlide);
      }
    });

    $('.main-slider-mobile').on('init', function(event,slick){
      if ($(window).width() < 760) {
        changeColorTheme(event, slick, 0);
        detectVideo(slick, 0);
        lasyLoadSlides(slick, 0);
      }
    });

    $('.main-slider-mobile').on('afterChange', function(event, slick, currentSlide){
      if ($(window).width() < 760) {
        changeColorTheme(event, slick, currentSlide);
        updateURLnTitle(slick, currentSlide);
        detectVideo(slick, currentSlide);
        lasyLoadSlides(slick, currentSlide);
        globalSlide = $(slick.$slides.get(currentSlide)).find(".grid-type").data('global-index');
        syncMainSlider(globalSlide);
      }
    });

    $('.main-slider-mobile').on('beforeChange', function(event, slick, currentSlide){
      if ($(window).width() < 760) {
        pauseVideo(slick, currentSlide);
      }
    });

    // Header contact
    $('#contact-content').delay(1000).queue(function(next){
        $(this).addClass("ready");
        next();
    });

    // Single portfolio page and landing page
    if( $('body').hasClass('single-portfolio') || $('body').hasClass('single-exhibition') && !($('.exhibition-nav.artworks').length)  ||  $('body').hasClass('template-landing') ) {
      $('.main-slider').slick({
        arrows: false,
        touchThreshold: 2500,
        speed: 200,
        responsive: [
          {
            breakpoint: 600,
            settings: "unslick",
          },
        ],
      });

      if(isSafari() && $(window).width() <= 1024) { //apply to safari and only if width is in iPhone/iPad-ish range
        $('div.size.medium').addClass('safari');
      }

      $('.main-slider-mobile').slick({
        arrows: false,
        touchThreshold: 2500,
        speed: 200,
      });

      var hash = window.location.hash;

      if(hash!==""){
        $('.main-slider').slick('slickGoTo', parseInt(hash.substring(1)) );
      } else {
        if($('body').hasClass('single-exhibition')) {
          //do nothing
        } else {
          window.history.pushState({"pageTitle":"Merrick d'Arcy-Irvine"},"", "/#0");
        }
      }

    }

    if(document.querySelector('.artworks-container, .press-release-container')) {
      document.querySelector('#footer').classList.add('rel');
    }

    // update nav color after resizing
    // update video embed container size after resizing
    var id;
    $(window).resize(function() {
      clearTimeout(id);
      id = setTimeout(doneResizing, 500);
      updateEmbedContainerSize();
    });

    function updateEmbedContainerSize() {
      if($(window).width() > 760 && $('.main-slider .slick-active .single-video').length){
        var $currentSlide = $('.main-slider .slick-active');
        var iframe = $currentSlide.find('iframe');

        $currentSlide.find('.embed-container').width( iframe.width() );
        $currentSlide.find('.embed-container').height( iframe.height() );
      }
    }

    function doneResizing() {

      var slick = $('.slick-slider:visible').slick('getSlick');
      var slideId = $('.slick-slider:visible').find('[data-global-index='+ globalSlide +']').first().attr('data-slick-index');

      if(slideId !== globalSlide) {
        if(slideId){
          $('.slick-slider:visible').slick('slickGoTo', slideId);
          updateUrlWithNoHistory(slideId);
        }
      }

      setTimeout(function(){
        var currentSlide = $('.slick-slider:visible').slick('slickCurrentSlide');

        if ($('.main-slider').hasClass('slick-initialized')) {
          if ($(window).width() < 768) {
            $('.nav-container-mobile .nav-arrow-l').removeClass('light');
            $('.nav-container-mobile .nav-arrow-r').removeClass('light');
            $('header').removeClass('light');

          } else {
            if ($('.main-slider .slick-active').data('nav-l-color') === 'white') {
              if (
                $(slick.$slides.get(currentSlide)).find('.i-left').length &&
                $(slick.$slides.get(currentSlide)).find('.i-left').hasClass('large')
                ||
                !$(slick.$slides.get(currentSlide)).find('.i-left').length &&
                $(slick.$slides.get(currentSlide)).find('.size').hasClass('large')
              ) {
                $('.nav-arrow-l').addClass('light');
              } else {
                $('.nav-arrow-l').removeClass('light');
              }
              $('header').addClass('light');
            } else {
              $('.nav-container .nav-arrow-l').removeClass('light');
              $('header').removeClass('light');
            }

            if ($('.main-slider .slick-active').data('nav-r-color') === 'white') {
              if (
                $(slick.$slides.get(currentSlide)).find('.i-right').length &&
                $(slick.$slides.get(currentSlide)).find('.i-right').hasClass('large')
                ||
                !$(slick.$slides.get(currentSlide)).find('.i-right').length &&
                $(slick.$slides.get(currentSlide)).find('.size').hasClass('large')
              ) {
                $('.nav-arrow-r').addClass('light');
              } else {
                $('.nav-arrow-r').removeClass('light');
              }
            } else {
              $('.nav-container .nav-arrow-r').removeClass('light');
            }
          }
        }

        if(slideId !== globalSlide) {
          $('.main-slider-mobile .single-video, .main-slider .playing').each(function () {
            stopVideo($(this)[0]);
          });
          if ($('.main-slider-mobile .single-video, .main-slider .playing').length > 0) {
            $('.main-slider-mobile .playing').removeClass('playing');
          }
          if ($('.main-slider .playing').length > 0) {
            $('.main-slider .playing').removeClass('playing');
          }
        }

      }, 50);
    }

    function updateListingItems(categories) {
      const cats = categories.split(",");
      const catOptions = {};
      let isAll = true;

      cats.forEach(function(cat) {
        catOptions[cat] = [];
        $(".field-group input[name^='" + cat + "']:checked").each(function() {
          if ($(this).val() !== "all") {
            isAll = false;
          }

          catOptions[cat].push( $(this).val() );
        })
      })

      $(".merrick-portfolio-item").each(function() {
        if (isAll) {
          $(this).show();
        } else {
          let shouldShow = false;
          let $item = $(this)

          cats.forEach(function(cat) {
            if (catOptions[cat][0] !== "all") {
              let itemCats = $item.data(cat).split(" ");

              itemCats.forEach(function(itemCat) {
                if (catOptions[cat].includes(itemCat)) {
                  shouldShow = true;
                }
              })
            }
          })

          if (shouldShow) {
            $(this).show();
          } else {
            $(this).hide();
          }
        }
      })
    }

    if ($(".filter-container").length) {
      if ($(window).width() > 768) {
        $(".hide-in-desktop").remove();
      } else {
        $(".hide-in-mobile").remove();
      }

      $(".filter-title").on("click", function() {
        $('body').toggleClass("menu-active");
        $(this).toggleClass("active");
        $(this).parent(".filter-container").find(".filter-options").toggleClass("show");
      });

      let loadMorePrintsEvent = new CustomEvent(
        "loadMorePrints",
        {
          detail: {
            time: new Date(),
          },
          bubbles: true,
          cancelable: true,
        }
      );

      if($('.merrick-portfolio-container').length) {
        const targetNode = document.querySelector('.merrick-portfolio-container');
        const config = {childList: true, subtree: true};
        const callback = function (mutationsList) {
          for (let i = 0; i<mutationsList.length; i++) {
            let mutation = mutationsList[i];
            if (mutation.type === 'childList') {
              if($('.load-more a:visible').length) {
                document.querySelector('.merrick-portfolio-container').dispatchEvent(loadMorePrintsEvent);
              } else {
                updateListingItems( $(".filter-container").data("categories") );
              }
            }
          }
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
      }

      $(".field-group input[type='checkbox']").on("click", function(e) {
        if($('body.post-type-archive-product').length) {
          //make sure we load all prints
          if($('.load-more a:visible').length) {
            document.querySelector('.merrick-portfolio-container').dispatchEvent(loadMorePrintsEvent);
          }
        }
        if ($(this).val() === "all") {
          if ( $(this).is(':checked') ) {
            // disable all sub input
            $(".field-group input").prop( "checked", false );
            $(".field-group input[value='all']").prop( "checked", true );
            // update dom
            updateListingItems( $(".filter-container").data("categories") );
          } else {
            e.preventDefault()
          }
        } else {
          // uncheck "all" input
          $("#" + $(this).attr("name") + "-all" ).prop( "checked", false );

          // if no box if checked, enable all
          if ( $(".field-group input[name^='" + $(this).attr("name") + "']:checked").length === 0 ) {
            $("#" + $(this).attr("name") + "-all" ).prop( "checked", true );
          }

          // update dom
          updateListingItems( $(".filter-container").data("categories") );
        }

        setTimeout(function() {
          // hide "all" option if one of the cat is not "all"
          if ( $(".field-group input[value='all']:checked").length < $(".field-group input[value='all']").length ) {
            $(".field-group input[value='all']").prop( "checked", false );
          }

          if ($(".field-group input:checked").length === 0) {
            $(".field-group input[value='all']").prop( "checked", true );
          }
        }, 0)
      });
    }

    $('.lazy').Lazy();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js